<template>
    <div id="agent_edit" class="agent-edit">
        <b-form>
            <b-col xl="10" lg="11" md="12">
                <b-form-group label="Name" label-for="name" label-cols="3" breakpoint="md" horizontal>
                    <b-form-input type="text" id="name" name="name" placeholder="name"
                                  v-model="agentData.user.name">
                    </b-form-input>
                </b-form-group>
                <b-form-group label="Email" label-for="email" label-cols="3" breakpoint="md" horizontal>
                    <b-form-input id="email" name="email" placeholder="email"
                                  v-model="agentData.user.email">
                    </b-form-input>
                </b-form-group>
                <b-form-group label="Phone" label-for="phone" label-cols="3" breakpoint="md" horizontal>
                    <b-form-input id="phone" name="phone" placeholder="phone"
                                  v-model="agentData.phone">
                    </b-form-input>
                </b-form-group>

                <b-form-group label="Bio" label-for="bio" label-cols="3" breakpoint="md" horizontal>
                    <vue-editor v-model="agentData.bio"></vue-editor>
                </b-form-group>

                <b-form-group>
                    <b-form-checkbox
                        id="checkbox-admin"
                        v-model="agentData.user.admin"
                        name="checkbox-admin"
                        value="1"
                        unchecked-value="0">
                        User is Admin
                    </b-form-checkbox>
                </b-form-group>
                <b-button type="submit" variant="primary" @click.stop="submit">Submit</b-button>
            </b-col>
        </b-form>
    </div>
</template>

<script>

export default {
    name: 'agent-edit',
    props: {
        agent: {
            type: Object,
            default: () => {}
        },
        editing: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            config: {
            },
            agentData: {
                phone: "",
                user: {
                    name: null,
                    email: null,
                    admin: 0,
                },
                testimonials: [
                ]
            },
            // editing: true,
            isLoading: true,
        }
    },
    created () {
        if(typeof this.agent !== 'undefined') {
            this.agentData = this.agent;
        }
    },
    methods: {
        submit(evt) {
            evt.preventDefault();
            let _self = this;
            let endpoint = _self.editing === true ? 'update' : 'create';
            let data = {
                agent: _self.agentData
            };
            axios.post('/api/agents/' + endpoint, data)
                .then(function (response) {
                    if (response.data.status === false) {
                        _self.$eventHub.$emit('message::send');
                    } else {
                        if (_self.editing === true) {
                            _self.$eventHub.$emit('agent::updated', "success");
                        } else {
                            _self.$eventHub.$emit('agent::created', "success");
                        }
                    }
                });
        }
    },
}

</script>
